import React from "react";

const TeamIcon = ({ color = "#0A61F5" }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_5172_1209)">
        <path
          d="M17.9079 0.890584H11.4277V3.77655L11.4512 3.77226C12.1841 3.63812 12.8594 4.201 12.8594 4.94612C12.8594 5.69127 12.1841 6.25424 11.4511 6.12018L11.4277 6.11588V8.75017H14.3746L14.3214 9.04115C14.1854 9.78411 14.7535 10.485 15.5087 10.474C16.2449 10.4633 16.7978 9.7929 16.6647 9.06587L16.6069 8.75017H19.2873V2.26999C19.2873 1.50816 18.6697 0.890584 17.9079 0.890584Z"
          fill="white"
          stroke={color}
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.4318 13.6641V12.2498H13.7515L13.8092 12.5655C13.9423 13.2925 13.3895 13.9629 12.6533 13.9736C11.8981 13.9846 11.3299 13.2837 11.4659 12.5408L11.5191 12.2498H8.57226V14.8598L8.54886 14.8555C7.81594 14.7214 7.14062 15.2843 7.14062 16.0295V16.0297C7.14062 16.7748 7.81597 17.3377 8.54886 17.2034L8.57226 17.1991V20.1094H15.0524C15.8143 20.1094 16.4318 19.4918 16.4318 18.73V17.5964"
          fill="white"
        />
        <path
          d="M16.4318 13.6641V12.2498H13.7515L13.8092 12.5655C13.9423 13.2925 13.3895 13.9629 12.6533 13.9736C11.8981 13.9846 11.3299 13.2837 11.4659 12.5408L11.5191 12.2498H8.57226V14.8598L8.54886 14.8555C7.81594 14.7214 7.14062 15.2843 7.14062 16.0295V16.0297C7.14062 16.7748 7.81597 17.3377 8.54886 17.2034L8.57226 17.1991V20.1094H15.0524C15.8143 20.1094 16.4318 19.4918 16.4318 18.73V17.5964"
          stroke={color}
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M0.712891 12.2498V18.73C0.712891 19.4918 1.33047 20.1094 2.0923 20.1094H8.57248"
          fill="white"
        />
        <path
          d="M0.712891 12.2498V18.73C0.712891 19.4918 1.33047 20.1094 2.0923 20.1094H8.57248"
          stroke={color}
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.59587 7.27188L8.57248 7.27614V4.39017H2.0923C1.33047 4.39017 0.712891 5.00778 0.712891 5.76958V12.2498H3.79136C3.81839 11.6286 4.33124 11.1104 4.98397 11.1104C5.63666 11.1104 6.14955 11.6286 6.17655 12.2498H8.57248V9.61551L8.59595 9.61976C9.32892 9.75386 10.0042 9.1909 10.0042 8.44578C10.0042 7.70063 9.32884 7.1377 8.59587 7.27188Z"
          fill="white"
          stroke={color}
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5172_1209">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TeamIcon;
